import React, { useState, useEffect } from "react"
import Switch from "@material-ui/core/Switch"
import { useStore } from "../../teafuljs/store"
import { makeStyles } from "@material-ui/core/styles"
import { getTranslation } from "../../scripts/getTranslation"

const useStyles = makeStyles(theme => ({
  settingsListContainer: {
    padding: 10,
  },
  settingsListHeader: {
    position: "relative",
    width: "100%",
    textAlign: "center",
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    textTransform: "uppercase",
    fontStyle: "underline",
  },
  settingsList: {
    display: "flex",
    flexDirection: "column",
  },
  singleSettingContainer: {
    flex: 1,
    display: "flex",
  },
  settingText: {
    flex: 4,
    fontSize: "80%",
    paddingTop: 5,
  },
  settingSwitch: {
    flex: 1,
    justifyContent: "flex-end",
  },
}))

const isBrowser = typeof window !== "undefined"

const SingleSetting = ({ label, updateSetting, checked }) => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()

  return (
    <div className={classes.singleSettingContainer}>
      <div className={classes.settingText}>
        {getTranslation(translations, language, "UI", label)}
      </div>
      <div className={classes.settingSwitch}>
        <Switch
          color="secondary"
          checked={checked}
          onChange={() => updateSetting(!checked)}
          value="single-setting"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      </div>
    </div>
  )
}

const DisplaySettings = () => {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [displayRef, setDisplayRef] = useStore.displayRef()
  const [showCurrentRef, setShowCurrentRef] = useStore.showCurrentRef()
  const [showTimePeriod, setShowTimePeriod] = useStore.showTimePeriod()
  const [showQA, setShowQA] = useStore.showQA()
  const [showGAP, setShowGAP] = useStore.showGAP()
  const [showGAPPopup, setShowGAPPopup] = useStore.showGAPPopup()
  const [showSpheres, setShowSpheres] = useStore.showSpheres();
  const [showValues, setShowValues] = useStore.showValues()
  const [showVerbs, setShowVerbs] = useStore.showValues()
  const classes = useStyles()
  const settingOptions = [
    {
      dispatchLabel: "UPDATE_DISPLAY_REF",
      label: "display_show_verse_ref",
      stateKey: "displayRef",
    },
    {
      dispatchLabel: "UPDATE_SHOW_CURRENT_REF",
      label: "display_show_current_ref",
      stateKey: "showCurrentRef",
    },
    {
      dispatchLabel: "UPDATE_SHOW_TIME_PERIOD",
      label: "display_show_time_period",
      stateKey: "showTimePeriod",
    },
    {
      dispatchLabel: "UPDATE_SHOW_QA",
      label: "display_showQA",
      stateKey: "showQA",
    },
  ]
  if (
    AvailableContent.content[language].versions[version]
      .layers &&
    AvailableContent.content[language].versions[
      version
    ].layers.includes("GAP")
  ) {
    settingOptions.push({
      dispatchLabel: "UPDATE_GAP",
      label: "display_showGAP",
      stateKey: "showGAP",
    })
  }
  if (
    AvailableContent.content[language].versions[version]
      .layers &&
    AvailableContent.content[language].versions[
      version
    ].layers.includes("spheres")
  ) {
    settingOptions.push({
      dispatchLabel: "UPDATE_SHOW_SPHERES",
      label: "display_show_sphereview",
      stateKey: "showSpheres",
    })
  }
  if (
    AvailableContent.content[language].versions[version]
      .layers &&
    AvailableContent.content[language].versions[
      version
    ].layers.includes("values")
  ) {
    settingOptions.push({
      dispatchLabel: "UPDATE_SHOW_VALUES",
      label: "display_show_values",
      stateKey: "showValues",
    })
  }
  if (
    AvailableContent.content[language].versions[version]
      .layers &&
    AvailableContent.content[language].versions[
      version
    ].layers.includes("interlinear")
  ) {
    settingOptions.push({
      dispatchLabel: "UPDATE_SHOW_INTERLINEAR",
      label: "display_show_interlinear",
      stateKey: "interlinear",
    })
  }
  if (
    AvailableContent.content[language].versions[version]
      .layers &&
    AvailableContent.content[language].versions[
      version
    ].layers.includes("verbs")
  ) {
    settingOptions.push({
      dispatchLabel: "UPDATE_SHOW_VERBS",
      label: "display_show_verbview",
      stateKey: "showVerbs",
    })
  }

  const getCurrentDisplayState = (stateKey) => {
    if (stateKey === "displayRef") {
      return [displayRef, setDisplayRef];
      }

    if (stateKey === "showCurrentRef") {
      return [showCurrentRef, setShowCurrentRef];
      }

    if (stateKey === "showTimePeriod") {
      return [showTimePeriod, setShowTimePeriod];
      }
    if (stateKey === "showQA") {
      return [showQA, setShowQA];
      }
    if (stateKey === "showGAP") {
      return [showGAP, setShowGAP]
    }
    if (stateKey === "showSpheres") {
      return [showSpheres, setShowSpheres];
      }
    if (stateKey === "showValues") {
      return [showValues, setShowValues];
      }
    if (stateKey === "showVerbs") {
      return [showVerbs, setShowVerbs];
      }
    if (stateKey === "showQA") {
      return [showQA, setShowQA];
      }
    if (stateKey === "showGAP") {
      return [showGAP, setShowGAP]
    }
  }

  return (
    <div className={classes.settingsListContainer}>
      <div className={classes.settingsListHeader}>
        {getTranslation(
          translations,
          language,
          "UI",
          "display_settings"
        )}
      </div>
      <div className={classes.settingsList}>
        {settingOptions.map((setting, index) => {
          const { label, stateKey } = setting;
          if (stateKey === 'showGAP') {
            // if (AvailableContent.content[language].versions[version]
            // .layers &&
            // !AvailableContent.content[language].versions[
            //   version
            //   ].layers.includes("showGAP")) {
            //   return null
            // };
          }

          const [state, setState] = getCurrentDisplayState(stateKey);
          return (
            <SingleSetting key={index} checked={state} label={label} updateSetting={() => {
              if (
                stateKey === "showQA" &&
                !showQA &&
                !displayRef &&
                isBrowser
              ) {
                localStorage.setItem("displayRef", true)
                setDisplayRef(true)
              }
              if (stateKey === "showGAP" && isBrowser) {
                console.log("DisplaySettings = showGAP", showGAP)
                if (!showGAP) {
                  setShowGAPPopup(true)
                } else {
                  setShowGAPPopup(false)
                }
              }
              if (stateKey === "showGAP" && (!showQA || !displayRef) && isBrowser) {
                if (!showQA) {
                  localStorage.setItem("showQA", true)
                  setShowQA(true)
                }
                if (!displayRef) {
                  localStorage.setItem("displayRef", true)
                  setDisplayRef(true)
                }
              }
              if (stateKey === "showSpheres") {
                if (!displayRef && !showSpheres && isBrowser) {
                  localStorage.setItem("displayRef", true)
                  setDisplayRef(true)
                }
                if (showValues) {
                  setShowValues(false)
                }
              }
              if (stateKey === "showValues") {
                if (!displayRef && isBrowser) {
                  localStorage.setItem("displayRef", true)
                  setDisplayRef(true)
                }
                if (showSpheres) {
                  setShowSpheres(false)
                }
              }
              localStorage.setItem(stateKey, !state)
              setState(!state)
            }} />
        )})}
      </div>
    </div>
  )
}

export default DisplaySettings
